import {
  SHOW_QUOTE_REQUEST_PUBLISHED_ERROR_DIALOG,
  CLOSE_QUOTE_REQUEST_PUBLISHED_ERROR_DIALOG
} from './QuoteRequestPublishedErrorDialog.actions'

const quoteRequestPublishedErrorDialogState = {
  open: false
}

/**
 * The quoteRequestPublishedErrorDialogState's reducer.
 */
const quoteRequestPublishedErrorDialogReducer = (state = quoteRequestPublishedErrorDialogState, { type }) => {
  switch (type) {
    case SHOW_QUOTE_REQUEST_PUBLISHED_ERROR_DIALOG: {
      return { ...state, open: true }
    }
    case CLOSE_QUOTE_REQUEST_PUBLISHED_ERROR_DIALOG: {
      return { ...state, open: false }
    }
    default: {
      return state
    }
  }
}

export default quoteRequestPublishedErrorDialogReducer
